(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('aether-cart-panel')) {
  customElements.define('aether-cart-panel', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal || this.ready) return;
      this.ready = true;
      this.status = this.querySelector('[data-panel-status]');
      this.list = this.querySelector('[data-panel-items]');
      this.empty = this.querySelector('[data-panel-empty]');
      this.footer = this.querySelector('[data-panel-footer]');
      this.checkout = this.querySelector('[data-panel-checkout]');
      this.total = this.querySelector('[data-panel-total]');
      this.onOpenClick = (event) => {
        const trigger = event.target.closest('.cart-link, #aether-toast-cta');
        if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = trigger;
        const menu = document.querySelector('.menu-toggle');
        if (menu && document.querySelector('.mobile-drawer.open')) menu.click();
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', this.dialog.id);
        trigger.setAttribute('aria-expanded', 'true');
        this.dialog.showModal();
        if (!this.busy) this.refresh();
      };
      this.onCartUpdated = () => {
        if (!this.dialog.open) return;
        if (this.busy) this.refreshPending = true;
        else this.refresh();
      };
      this.onPageShow = this.onCartUpdated;
      document.addEventListener('click', this.onOpenClick);
      window.addEventListener('cart:updated', this.onCartUpdated);
      window.addEventListener('pageshow', this.onPageShow);
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-panel-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        if (this.opener && this.opener.isConnected) {
          this.opener.setAttribute('aria-expanded', 'false');
          this.opener.focus();
        }
        if (this.cartPageDirty && !this.busy) window.location.reload();
      });
      this.querySelector('form').addEventListener('submit', (event) => {
        if (this.busy || !this.cart || !this.cart.item_count) event.preventDefault();
      });
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onOpenClick);
      window.removeEventListener('cart:updated', this.onCartUpdated);
      window.removeEventListener('pageshow', this.onPageShow);
    }
    setBusy(busy) {
      this.busy = busy;
      this.list.setAttribute('aria-busy', String(busy));
      this.list.querySelectorAll('button').forEach(button => { button.disabled = busy || !this.cart; });
      this.checkout.disabled = busy || !this.cart || !this.cart.item_count;
    }
    finish() {
      this.setBusy(false);
      if (this.cartPageDirty && !this.dialog.open) { window.location.reload(); return; }
      if (this.refreshPending && this.dialog.open) { this.refreshPending = false; this.refresh(); }
    }
    async refresh() {
      this.setBusy(true);
      this.status.textContent = this.dataset.loading;
      try {
        const response = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('cart');
        this.render(await response.json());
        this.status.textContent = '';
      } catch {
        this.cart = null;
        this.status.textContent = this.dataset.error;
        this.footer.hidden = false;
      } finally { this.finish(); }
    }
    async change(key, quantity) {
      if (this.busy || !this.cart) return;
      this.cartPageDirty = window.location.pathname.replace(/\/$/, '') === this.dataset.cartUrl.replace(/\/$/, '');
      this.setBusy(true);
      this.status.textContent = this.dataset.loading;
      try {
        const response = await fetch(this.dataset.changeUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) throw new Error('change');
        this.render(await response.json());
        this.status.textContent = '';
        this.dialog.querySelector('[data-panel-close]').focus();
      } catch {
        this.cart = null;
        this.status.textContent = this.dataset.error;
      } finally { this.finish(); }
    }
    render(cart) {
      if (!Array.isArray(cart.items) || !cart.currency || typeof cart.item_count !== 'number') throw new Error('cart');
      this.cart = cart;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(cents / 100);
      const make = (tag, className, text) => { const el = document.createElement(tag); el.className = className; if (text !== undefined) el.textContent = text; return el; };
      const items = document.createDocumentFragment();
      cart.items.forEach(item => {
        const row = make('li', 'aether-cart-panel__item');
        if (item.image) {
          const img = make('img', 'aether-cart-panel__image');
          const url = new URL(item.image, window.location.origin);
          url.searchParams.set('width', '128');
          img.src = url.href; img.alt = ''; img.width = 64; img.height = 64;
          row.append(img);
        } else row.append(make('span', 'aether-cart-panel__image'));
        const body = make('div', '');
        const name = make('a', 'aether-cart-panel__name', item.product_title || item.title);
        name.href = item.url; body.append(name);
        if (item.variant_title && item.variant_title !== 'Default Title') body.append(make('p', 'aether-cart-panel__variant', item.variant_title));
        if (item.selling_plan_allocation) body.append(make('p', 'aether-cart-panel__variant', item.selling_plan_allocation.selling_plan.name));
        body.append(make('p', 'aether-cart-panel__price', money(item.final_line_price)));
        const controls = make('div', 'aether-cart-panel__controls');
        const stepper = make('div', 'aether-cart-panel__stepper');
        stepper.setAttribute('role', 'group'); stepper.setAttribute('aria-label', this.dataset.quantity + ': ' + item.product_title);
        [-1, 1].forEach((delta, index) => {
          if (index) stepper.append(make('span', '', String(item.quantity)));
          const button = make('button', '', delta < 0 ? '−' : '+'); button.type = 'button';
          button.setAttribute('aria-label', this.dataset.quantity + ': ' + Math.max(0, item.quantity + delta) + ' · ' + item.product_title);
          button.addEventListener('click', () => this.change(item.key, Math.max(0, item.quantity + delta))); stepper.append(button);
        });
        const remove = make('button', 'aether-cart-panel__remove', this.dataset.remove); remove.type = 'button';
        remove.setAttribute('aria-label', this.dataset.remove + ': ' + item.product_title);
        remove.addEventListener('click', () => this.change(item.key, 0));
        controls.append(stepper, remove); body.append(controls); row.append(body); items.append(row);
      });
      this.list.replaceChildren(items);
      this.empty.hidden = cart.item_count !== 0;
      this.footer.hidden = cart.item_count === 0;
      this.total.textContent = money(cart.total_price);
      document.querySelectorAll('.cart-count, [data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('aether-donation-presets')) {
  customElements.define('aether-donation-presets', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-donation-amount]');
        if (!button || !this.contains(button)) return;
        const input = this.closest('form')?.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.donationAmount;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
